import React, { Component,useState,useEffect } from 'react';
import db from "../../Utils/api";
import styled from "styled-components";
import WhatsappButton from "../../Components/WhatsappButton";
import Loader from '../../Components/Loader';
import { useLocation } from 'react-router';
import realtimeDB from '../../Utils/api';
import Header from '../../Components/Lista/HeaderCheckin';
import PrimaryButton from "../../Components/PrimaryButton";
import {useHistory} from "react-router-dom";

const Container=styled.div`
position: absolute;
top:0;
bottom: 0;
left: 0;
right: 0;
margin: auto;
display:grid;
justify-content:center;
align-content:center;
`;

const Text=styled.p`
font-size:20px;
text-align:center;
margin:0 10%;`;

const CustomerCancel=()=>
{
    useEffect(async () => 
    {
        const ID=String(window.location.pathname).replace("/lista/","").replace("/cancelar","");
        await realtimeDB.ref("/Customers").child(ID).remove();
    }, []);


    return <>
     <Container>
    <Text>Ya no están mas en la lista!<span role="img" aria-label="Emoji mirando para abajo">😔</span></Text>
    <Text>Pero pueden anotarse de nuevo cuando quieran<span role="img" aria-label="Emoji manitos">🙌</span></Text>
    </Container>
    <WhatsappButton bottom="0.25em" number="5491138141940" show={true}/>
    </>
}

export default CustomerCancel;

